// import CountryService from '../../services/CountryService';

export const isTwoLineAddressMode = () => {
  // const { country } = CountryService.GetInstance();

  // if (country && country.code && country.code.toLowerCase() === 'cz') {
  //   return false;
  // }

  return true;
};


// WEBPACK FOOTER //
// ./src/helpers/address/isTwoLineAddressMode.ts